<data-table
  label="Campaigns"
  [seamless]="true"
  [loading]="loading"
  [maxHeight]="'none'"
  [skeletonColumns]="6"
  [resizable]="false"
>
  <table class="bk-log">
    <thead>
      <tr>
        <th scope="col">Campaign</th>
        <th scope="col" class="col-status">Status</th>
        <th scope="col" class="col-outcome">Delivery</th>
        <th scope="col" class="col-next">Next send</th>
        <th scope="col" class="col-run">Runs</th>
        <th scope="col" class="col-created">Created</th>
        <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track row.key) {
        <tr
          [class.is-link]="canView"
          [attr.tabindex]="canView ? 0 : null"
          (click)="openRow(row)"
          (keydown.enter)="openFromKeyboard($event, row)"
        >
          <td class="col-name">
            <span class="bk-msg">
              <span class="bk-msg__subject">{{ row.name }}</span>
              @if (row.description) {
                <span class="bk-msg__preview">{{ row.description }}</span>
              }
            </span>
          </td>
          <td class="col-status">
            @if (row.status) {
              <app-status [text]="row.status" [status]="row.tone" />
            } @else {
              <span class="cell-none">No status</span>
            }
          </td>
          <td class="col-outcome" [class.is-quiet]="row.unsent">
            <bk-campaign-outcome [campaign]="row.campaign" />
          </td>
          <td class="col-next" [class.is-quiet]="!row.live">
            <bk-campaign-next-send [campaign]="row.campaign" [now]="now" />
          </td>
          <td class="col-run">
            <span class="run">
              <span class="run__dates">{{ row.run }}</span>
              @if (row.runLength) {
                <span class="run__length">{{ row.runLength }}</span>
              }
            </span>
          </td>
          <td class="quiet col-created">{{ row.created }}</td>
          <td class="col-actions">
            <span class="bk-row-actions">
              <ng-container
                *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'view-campaign-analytics' }"
              >
                <button
                  type="button"
                  class="bk-icon-btn"
                  [attr.aria-label]="'View report for ' + row.name"
                  matTooltip="View report"
                  (click)="$event.stopPropagation(); openReport(row)"
                >
                  <span class="bk-sym" aria-hidden="true">monitoring</span>
                </button>
              </ng-container>
              <ng-container *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'create-campaigns' }">
                <button
                  type="button"
                  class="bk-icon-btn"
                  [class.is-busy]="isDuplicating(row)"
                  [attr.aria-label]="'Duplicate ' + row.name"
                  [attr.aria-busy]="isDuplicating(row) || null"
                  [attr.aria-disabled]="duplicatingId !== null || null"
                  matTooltip="Duplicate as a new campaign"
                  (click)="$event.stopPropagation(); duplicatingId === null && duplicate.emit(row.campaign)"
                >
                  <span class="bk-sym" [class.is-pulsing]="isDuplicating(row)" aria-hidden="true">content_copy</span>
                </button>
              </ng-container>
              <ng-container *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'delete-campaigns' }">
                <button
                  type="button"
                  class="bk-icon-btn is-danger"
                  [attr.aria-label]="'Delete ' + row.name"
                  matTooltip="Delete"
                  (click)="$event.stopPropagation(); showDelete.emit(row.campaign.id)"
                >
                  <span class="bk-sym" aria-hidden="true">delete</span>
                </button>
              </ng-container>
              @if (canView) {
                <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
              }
            </span>
          </td>
        </tr>
      }
    </tbody>
  </table>
</data-table>
